import { render, staticRenderFns } from "./LeadBoardCreateDealSidebar.vue?vue&type=template&id=040f461a&"
import script from "./LeadBoardCreateDealSidebar.vue?vue&type=script&lang=js&"
export * from "./LeadBoardCreateDealSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports